import { deleteEmpleado, getEmpleadosPanel} from "../../services/EmpleadosServices";
import { EmpleadosContext } from "./EmpleadosContext"

export const EmpleadosState = ({ children }) => {
     const getEmpleadosPanelData = async (searchTerm,numPagina, filas) => {
        let res = await getEmpleadosPanel(searchTerm,numPagina, filas);
        return res
    }

    const deleteEmpleadoData = async (body,searchTerm,numPagina, filas) => {
        const res = await deleteEmpleado(body)
        if (res) getEmpleadosPanelData(searchTerm,numPagina, filas)
        return res
    }

    return <EmpleadosContext.Provider value={{
        deleteEmpleadoData,
        getEmpleadosPanelData
    }} >
        {children}
    </EmpleadosContext.Provider>
}